var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"flex-card",attrs:{"height":"100%"}},[(_vm.subStep.description)?_c('v-card-title',[_vm._v(" "+_vm._s(_vm.subStep.description.toUpperCase())+" ")]):_vm._e(),_c('v-divider'),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }